
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Button,
    FormControl,
    InputLabel,
    Select,
    Paper,
    Tooltip,
    Chip
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import AddIcon from "@mui/icons-material/Add";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        EmailRecipientModel,
        RecordModel} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../components/searchField/SearchField";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../utils/helperRouter";
import {validateEmailField} from '../../utils/fieldValidations';


export const EmailSubjectComponent: React.FC<{
  subject: string,
  onChange: (event: any) => void
}> = ({
  subject,
  onChange
}) => {

  const styles = ContainerClasses();

  const error = () => {
    if(subject === "") return true;
      return false
    };

  return (
   <Box sx={{...styles.containerRowB,
             pt: '1rem',
             pl: '1rem',
             pr: '1rem',
             gap: '1rem'}}>

     <Typography
        variant="subtitle1"
      >
       Subject:
     </Typography>


     <TextField
          fullWidth
          error={error()}
          required={true}
          size="small"
          label="Subject"
          variant="filled"
          value={subject}
          onChange={onChange}
          inputProps={{
            maxLength: 255,
            onClick: () => {}
          }}
        />
      </Box>
    )
};
